import { API } from "src/server/api";

class PublicApi {
  async getOverview(request) {
    const response = await API.post("public/overview", request);

    let stations = response.data.stations;
    let overview = response.data.overview;

    return Promise.resolve({
      stations,
      overview,
    });
  }

  async prepare() {
    const response = await API.get("public/prepare");

    let status = response.data.status;

    return Promise.resolve({
      status,
    });
  }

  async getThumbnail(imageId) {
    const response = await API.get("public/thumbnail/" + imageId);

    let image = response.data.image;

    return Promise.resolve({
      image,
    });
  }
}

export const publicApi = new PublicApi();
